import { getCurrencyFormat } from '../utils/utils.js'
import NumberParser from '../leasing-calculator/NumberParser.js'

// Calculation of the results
export function updateCalculation (
  jsonData,
  leasingRuntimeDropdown,
  leasingMoneyInput,
  countrySelect,
  leasingResult,
  selectedProvision
) {
  // Find the selected country based on the selected locale from the dropdown
  const selectedCountry = jsonData.documents[countrySelect.value]?.ilcDocument

  // Check if the selected country, monthsAndFactors, and values exist; if not, exit the function
  if (!selectedCountry || !selectedCountry.monthsAndFactors || !selectedCountry.values) {
    return
  }

  const runtimeValue = leasingRuntimeDropdown.value // The currently selected month

  // Get the values and factors for the selected country and runtime
  const valuesArray = selectedCountry.values // Array of value ranges
  const factorsArray = selectedCountry.monthsAndFactors[runtimeValue] // Array of factors for the selected month
  const currency = selectedCountry.countryAndCurrencyCompoundModel.currency // Get the currency
  const locale = selectedCountry.countryAndCurrencyCompoundModel.languageTag // Get the locale

  // Get MoneyValue from Inputfield
  const cleanedMoneyValue = leasingMoneyInput.value.match(/\d|[,.]/g)?.join('') || ''
  const moneyValue = new NumberParser(locale).parse(cleanedMoneyValue) || leasingMoneyInput.value // The entered amount of money

  // Ensure we have sufficient data in both the valuesArray and factorsArray for calculations
  if (!factorsArray || !valuesArray || valuesArray.length < 2 || factorsArray.length < 1) {
    return // Fallback if data is incomplete or invalid
  }

  // Iterate through the valuesArray to handle range pairs
  for (let i = 0; i < valuesArray.length - 1; i++) {
    const lowerBound = valuesArray[i] // Lower bound of the range
    const upperBound = valuesArray[i + 1] // Upper bound of the range

    // Check if moneyValue falls within the range
    if (moneyValue >= lowerBound && moneyValue < upperBound) {
      const factor = factorsArray[i] // Use the factor corresponding to the current value range
      const result = calculateResult(moneyValue, factor, selectedProvision)
      updateResultDisplay(leasingResult, result, currency, locale)
      return
    }
  }

  // If the moneyValue exceeds the highest value in the valuesArray, use the last non-zero factor from factorsArray
  if (moneyValue > valuesArray[valuesArray.length - 1]) {
    // Iterate through the factorsArray to find the last non-zero factor
    let lastNonZeroFactor = 0

    for (let i = factorsArray.length - 1; i >= 0; i--) {
      if (factorsArray[i] !== 0) {
        lastNonZeroFactor = factorsArray[i]
        break // Stop once we find the last non-zero factor
      }
    }

    if (lastNonZeroFactor !== 0) {
      const result = calculateResult(moneyValue, lastNonZeroFactor, selectedProvision)
      updateResultDisplay(leasingResult, result, currency, locale)
    } else {
      updateResultDisplay(leasingResult, null, currency, locale)
    }

    return
  }

  // If no valid range was found for the money value, display no result
  leasingResult.textContent = ''
}

function calculateResult (moneyValue, factor, selectedProvision) {
  // Calculate the base result
  const baseResult = (moneyValue * factor) / 100

  // Apply the provision multiplier based on the value of selectedProvision
  const provisionMultiplier = 1 + parseFloat(selectedProvision) / 100

  // Return the adjusted result
  return baseResult * provisionMultiplier
}

// Function to update the result display
function updateResultDisplay (leasingResult, result, currency, locale) {
  if (result !== null && result !== undefined) {
    leasingResult.textContent = `${getCurrencyFormat(locale, currency, result)}`
  } else {
    leasingResult.textContent = ''
  }
}
